import { useMemo } from 'react';

import { QuestionnaireContent, hasUnacceptableAnswer, isQuestionAnswered } from 'Models/DueDiligence';

export interface QuestionnaireStatistics {
    totalQuestions: number;
    answeredQuestions: number;
    unansweredRequiredQuestions: number;
    unacceptableAnswers: number;
}

export const useQuestionnaireStatistics = (questionnaire: QuestionnaireContent): QuestionnaireStatistics => {
    return useMemo(() => {
        let total = 0;
        let answered = 0;
        let unansweredRequired = 0;
        let unacceptable = 0;

        questionnaire.control_frameworks.forEach((framework) => {
            framework.control_groups.forEach((group) => {
                group.controls.forEach((control) => {
                    control.questions.forEach((question) => {
                        total++;

                        if (isQuestionAnswered(question)) {
                            answered++;
                        } else if (question.is_required) {
                            unansweredRequired++;
                        }

                        if (hasUnacceptableAnswer(question)) {
                            unacceptable++;
                        }
                    });
                });
            });
        });

        return {
            totalQuestions: total,
            answeredQuestions: answered,
            unansweredRequiredQuestions: unansweredRequired,
            unacceptableAnswers: unacceptable,
        };
    }, [questionnaire]);
};
